import { Injectable, Injector } from '@angular/core';
import { SynchronizationServiceBase } from './synchronization-service-base';
import { SynchronizationEntity } from './synchronization-entity';
import { TeamRepository } from '../local-db/repositories/team-repository';

@Injectable({ providedIn: 'root' })
export class TeamSyncService extends SynchronizationServiceBase {
  constructor(injector: Injector, private readonly _teamRepo: TeamRepository) {
    super(injector, SynchronizationEntity.Teams);
  }

  public async synchronize(): Promise<void> {
    await this._teamRepo.refreshTeams();
  }
}
